import * as React from 'react';
import { NumberInput, InputGroup, UIHeading4 } from '@cian/ui-kit';

import { Adornment } from '../Adornment';
import * as styles from './InputsMultiple.css';

interface IInputProps extends React.HTMLProps<HTMLInputElement> {
  onChangeValue(value: number | undefined): void;
  rightAdornment?: React.ReactNode;
  leftAdornment?: React.ReactNode;
}

export interface IInputsMultipleProps extends React.HTMLProps<HTMLInputElement> {
  label?: string;
  stack: IInputProps[];
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
}

export function InputsMultiple(props: IInputsMultipleProps) {
  const { stack, label } = props;

  return (
    <div className={styles['field']}>
      {label && <UIHeading4>{label}</UIHeading4>}
      <div className={styles['stack']}>
        <InputGroup>
          {stack.map((stackProps, index) => {
            const handleChange = (value: number | undefined) => stackProps.onChangeValue(value);

            return (
              <NumberInput
                key={index}
                size="M"
                disabled={props.disabled}
                placeholder={stackProps.placeholder}
                value={stackProps.value ? Number(stackProps.value) : undefined}
                aria-label={stackProps['aria-label']}
                onChange={handleChange}
                rightAdornment={stackProps.rightAdornment && <Adornment>{stackProps.rightAdornment}</Adornment>}
                leftAdornment={stackProps.leftAdornment && <Adornment>{stackProps.leftAdornment}</Adornment>}
              />
            );
          })}
        </InputGroup>
      </div>
    </div>
  );
}
